import type { TODO } from '@/types'
import { defineStore } from 'pinia'
import { computed, reactive, ref } from 'vue'
import resourceService from '@/services/http/api/resource'

export const useNextEditionGuardianConsent = defineStore('nextEditionGuardianConsent', () => {
  const form = reactive<TODO>({
    consents: {}
  })

  const resource = ref<TODO>(null)

  const setForm = (formData: TODO) => {
    Object.assign(form, formData)
  }

  const fetchResource = async (
    type = 'next-edition-application',
    isPublic = true,
    editionName = '2024'
  ) => {
    const { data } = await resourceService.document(type, isPublic, editionName)
    resource.value = data?.data
    return resource.value
  }

  const getQuestions = computed(() => resource.value?.document_questions?.next_edition_application)

  const getResourceGroups = computed(() => resource.value?.document_resource_groups ?? null)

  return { resource, fetchResource, getQuestions, form, getResourceGroups, setForm }
})
